import { Path, Svg, type SvgProps } from 'react-native-svg';

export const NavioHorse = ({ color, ...props }: SvgProps) => (
  <Svg viewBox='0 0 24 24' fill='none' {...props}>
    <Path
      d='M6 20h12c0-4-1-7-4-10l1-5-4-2v3L8 8l-4 4 1 4 4-1 2-3M10 15c-1 2-3 3-4 5M10 9h.01'
      stroke={color}
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </Svg>
);
